import { Button as DefaultButton } from '@kega/sps-elements';
import classNames from 'classnames';

import { ShoppingbagIcon } from '../icons';

import classes from './Button.module.css';

const AddToCart = ({ children, className = null, ...props }) => {

    const classesGroup = classNames(classes.root, classes.atc, className);

    return (
        <DefaultButton className={classesGroup} {...props} >
            {children}<ShoppingbagIcon size={20} className={classNames(classes['inline-icon'])} title="toevoegen-product" />
        </DefaultButton>
    );
}

export default AddToCart;